import { Button, Form, Row, Space, Spin, message, Popconfirm, Select, Col } from 'antd';
import { useNavigate, useParams } from 'react-router';
import { createContext, useCallback, useEffect, useState } from 'react';
import {
  cancelPrescription,
  getInitialConfig,
  getPartnerUser,
  getPrescriptionById,
  savePrescription,
} from '../../Services/Prescription.service';
import CustomerDetailForm from '../../Component/Prescription/CustomerDetailForm';
import PresrciptionDetailForm from '../../Component/Prescription/PresrciptionDetailForm';
import DeliveryDetailForm from '../../Component/Prescription/DeliveryDetailForm';
import CommentDetailForm from '../../Component/Prescription/CommentDetailForm';

import dayjs from 'dayjs';
import { getProfileAddress } from '../../Services/Profile.service';
import { PartnerType } from './InterfaceType';

export const DataContext = createContext<any>({});

const PrescriptionForm = () => {
  const navigate = useNavigate();
  const username = window.sessionStorage.getItem('username');
  const partnerCode = window.sessionStorage.getItem('partner_code');
  const language = 'th';
  const paramId = useParams();
  const BDSMEDLINK = 'BDSMEDLINK';
  const [isLoading, setIsLoading] = useState(false);
  const [prescriptId, setPrescriptId] = useState('');
  const [prescriptData, setPrescriptData] = useState<any>();
  const [action, setAction] = useState('');
  const [initialData, setInitialData] = useState();
  const [isDraftBtnHidden, setIsDraftBtnHidden] = useState(false);
  const [isSubmitBtnHidden, setIsSubmitBtnHidden] = useState(false);
  const [isCancelBtnHidden, setIsCancelBtnHidden] = useState(false);
  const [deliveryType, setDeliveryType] = useState('');
  const [listImage, setListImage] = useState<string[]>([]);
  const [checkItemList, setCheckItemList] = useState<any[]>([]);
  const [form] = Form.useForm();
  const [addressData, setAddressData] = useState<any[]>([]);
  const [profileId, setProfileId] = useState('');
  const [isRefetch, setIsRefetch] = useState(true);
  const [partnerList, setPartnerList] = useState<PartnerType[]>([]);
  const [selectedSource, setSelectedSource] = useState('');
  const [itemOnHandBalance, setItemOnHandBalance] = useState<any[]>([]);
  const [profileDeliveryAddressId, setProfileDeliveryAddressId] = useState('');
  const { Option } = Select;

  useEffect(() => {
    if (paramId.id !== 'create') {
      fetchData();
      setPrescriptId(String(paramId.id));
    } else {
      setPrescriptId('000000000000000000000000');
      setIsCancelBtnHidden(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnerList]);

  const fetchData = async () => {
    const res = await getPrescriptionById(paramId.id || '');
    setPrescriptData(res.datas);
    setDeliveryType(res.datas?.delivery_info?.type);
    setProfileDeliveryAddressId(res.datas?.delivery_info?.profile_address_id || '');

    if (res.datas.status === 'DRAFT' || res.datas.status === 'REJECT') {
      setIsDraftBtnHidden(false);
      setIsSubmitBtnHidden(false);
      setIsCancelBtnHidden(false);
    } else {
      setIsDraftBtnHidden(true);
      setIsSubmitBtnHidden(true);
      setIsCancelBtnHidden(true);
    }
  };

  useEffect(() => {
    if (prescriptData && prescriptData.source) {
      form.setFieldsValue({
        partner_user: prescriptData.source,
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prescriptData]);

  useEffect(() => {
    if (selectedSource) {
      form.setFieldsValue({
        partner_user: selectedSource,
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSource]);

  const changePartnerUser = (value: any) => {
    setSelectedSource(value);
  };

  const fetchInitialConfig = useCallback(
    async (coords?: { latitude: number; longitude: number }) => {
      const data: any = {
        partner_code: partnerCode === BDSMEDLINK && selectedSource ? selectedSource : partnerCode,
        username: username,
        language: language,
        user_login: partnerCode,
      };

      if (coords) {
        data.latitude = coords.latitude;
        data.longitude = coords.longitude;
        data.total_price = form.getFieldValue('total_price') || 0;
      }

      const res = await getInitialConfig(data);
      setInitialData(res?.datas);
    },
    [selectedSource, partnerCode, username, language, form],
  );

  useEffect(() => {
    fetchInitialConfig();
  }, [fetchInitialConfig]);

  const onFastDeliveryAddressSelected = (latitude: number, longitude: number) => {
    fetchInitialConfig({ latitude, longitude });
  };

  const onSavePrescription = async (datas: any) => {
    const [latitude, longitude] = datas.latitude_longitude
      ? datas.latitude_longitude.split(',').map(parseFloat)
      : [0, 0];

    setIsLoading(true);

    if (datas.label_language === 'en' && Array.isArray(datas.detail) && datas.detail.length > 0) {
      const invalidItem = datas.detail.find((item: any) => {
        const enLabel = item?.label_by_lang?.en || {};

        return !enLabel.item_memo?.trim() || !enLabel.item_method?.trim();
      });

      if (invalidItem) {
        message.open({
          type: 'error',
          content:
            'กรุณากรอกข้อมูล ข้อบ่งใช้ (Indications) และ วิธีใช้ (Dosage and Administration) ในภาษาอังกฤษให้ครบถ้วน',
        });
        setIsLoading(false);
        return;
      }
    }

    const data = {
      id: prescriptId,
      address_source: partnerCode,
      action: action,
      update_by: username,
      partner_code: partnerCode,
      created_by_source: prescriptData?.created_by_source || partnerCode,
      remark: datas.remark,
      source: selectedSource || prescriptData?.source || partnerCode,
      label_language: datas.label_language,
      personal_info: {
        action: datas.button_action,
        phone_number: datas.phone_number,
        date_of_birth: dayjs(datas.date_of_birth).format('YYYY-MM-DD'),
        citizen_id: datas.citizen_id,
        passport_id: datas.passport_id,
        first_name: datas.first_name,
        last_name: datas.last_name,
        gender: datas.gender,
        congenital_disease: datas.congenital_disease,
        drug_allergy: datas.drug_allergy,
        nation: datas.nation,
        weight: datas.weight,
        height: datas.height,
        email: datas.email,
      },
      prescript_info: {
        no: datas.prescript_no,
        date: dayjs(datas.prescript_date).format('YYYY-MM-DD'),
        doctor_id: datas.doctor_id,
        descritpion: '',
        symptom: datas.symptom,
        diagnosis: datas.diagnosis,
        attachment: listImage,
        detail: datas.detail,
        total_price: datas.total_price || 0,
        delivery_price: datas.delivery_price || 0,
        paid: datas.paid || 0,
        extra_payment: datas.extra_payment || 0,
        sub_account: datas.sub_account,
      },
      delivery_info: {
        profile_address_id: profileDeliveryAddressId || '',
        type: datas.delivery_type,
        by: '2',
        moi_code: datas.delivery_sub_district_code,
        address: datas.delivery_address,
        phone_number: datas.delivery_phone_number,
        zip_code: datas.delivery_zip_code,
        fullname: datas.delivery_fullname,
        latitude: latitude,
        longitude: longitude,
        site_id: datas.delivery_site,
        is_save_address: datas.is_save_address,
        note_to_rider: datas.note_to_rider,
      },
    };

    const formData = new FormData();
    formData.append('data', JSON.stringify(data));

    if (datas.attachmentFile) {
      datas.attachmentFile.forEach((file: any) => {
        formData.append('files', file);
      });
    }

    console.log('datas.detail', datas.detail);
    console.log('formData', formData);

    const res = await savePrescription(formData);
    setIsLoading(false);

    if (res?.data.res_code === '000') {
      message.success('บันทึกข้อมูลเสร็จสิ้น');
      navigate('/');
    } else if (res?.data.res_code === 'E101') {
      message.error(
        'ตรวจสอบข้อมูลไม่สำเร็จ ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบข้อมูลอีกครั้ง หรือ ติดต่อ Call Center: 02-538-2229',
        10,
      );
    } else if (res?.data.res_code === 'E104') {
      message.error('สินค้าไม่เพียงพอ', 10);
    } else {
      message.error('ไม่สามารถบันทึกได้โปรดลองอีกครั้ง');
    }
  };
  const handleSubmit = (value: any) => {
    setAction(value);
    form.submit();
  };

  const handleCancel = async (value: any) => {
    const update_by = window.sessionStorage.getItem('username') ?? '';
    const res = await cancelPrescription(value, update_by);
    if (res?.data.res_code === '000') {
      message.success('ยกเลิกสำเร็จ');
      navigate('/');
    }
  };

  const handleOnChangeDeliveryType = (value: any) => {
    setDeliveryType(value);
  };

  const updateItemOnHandBalance = (balance: number) => {
    setItemOnHandBalance([balance]);
  };

  useEffect(() => {
    if (profileId !== '' && isRefetch) {
      getProfileAddressData(profileId);
    }
  }, [profileId, isRefetch]);

  const getProfileAddressData = async (id: string) => {
    const resAddress = await getProfileAddress(id);
    setAddressData(resAddress.datas?.delivery_address || []);
    setIsRefetch(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (partnerCode === BDSMEDLINK) {
        const resPartnerUser = await getPartnerUser();
        setPartnerList(resPartnerUser.datas);
      }
    };
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const datas = { initialData, prescriptData, addressData, setIsRefetch };

  const filterOption = (input: string, option: any) => {
    const optionText = `${option.children}`.toLowerCase();
    return optionText.includes(input.toLowerCase());
  };

  return (
    <div>
      {partnerCode === BDSMEDLINK ? (
        <Col span={6}>
          <Form layout="vertical" form={form} disabled={isSubmitBtnHidden}>
            <Form.Item label={'รหัสพาร์ทเนอร์ / ชื่อพาร์ทเนอร์'} name={'partner_user'} rules={[{ required: true }]}>
              <Select
                showSearch
                allowClear
                filterOption={filterOption}
                placeholder="เลือกพาร์ทเนอร์"
                onChange={changePartnerUser}
              >
                {partnerList.map((e, index: number) => (
                  <Option key={index} value={e.partner_code}>
                    {e.partner_code} / {e.partner_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </Col>
      ) : null}

      <DataContext.Provider value={datas}>
        <Spin spinning={isLoading}>
          <CustomerDetailForm form={form} onFinish={onSavePrescription} setProfileId={setProfileId} />

          <PresrciptionDetailForm
            form={form}
            onFinish={onSavePrescription}
            deliveryType={deliveryType}
            setListImage={setListImage}
            listImage={listImage}
            setCheckItemList={setCheckItemList}
            itemOnHandBalance={itemOnHandBalance[0] || 0}
          />

          <DeliveryDetailForm
            form={form}
            onFinish={onSavePrescription}
            onChangeDeliveryType={handleOnChangeDeliveryType}
            profileId={profileId}
            checkItemList={checkItemList}
            itemOnHandBalance={itemOnHandBalance}
            updateItemOnHandBalance={updateItemOnHandBalance}
            onChangeProfileDeliveryAddress={setProfileDeliveryAddressId}
            onFastDeliveryAddressSelected={onFastDeliveryAddressSelected}
          />

          <Space style={{ marginBottom: 20, marginTop: 30 }}>
            <Row gutter={24} style={{ gap: 15, justifyContent: 'flex-end' }}>
              {!isDraftBtnHidden ? (
                <Button disabled={isDraftBtnHidden} onClick={() => handleSubmit('DRAFT')}>
                  บันทึกแบบร่าง
                </Button>
              ) : (
                ''
              )}

              {!isSubmitBtnHidden ? (
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    display: 'flex',
                    color: 'white',
                    width: '120px',
                    justifyContent: 'center',
                    backgroundColor: '#50B0E9',
                  }}
                  disabled={isSubmitBtnHidden}
                  onClick={() => handleSubmit('SUBMIT')}
                >
                  ส่งข้อมูล
                </Button>
              ) : (
                ''
              )}

              {!isCancelBtnHidden ? (
                <Popconfirm
                  placement="top"
                  title={'ยืนยันการยกเลิกรายการนี้ใช่หรือไม่?'}
                  onConfirm={() => handleCancel(prescriptId)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: '#F25F0A',
                      display: 'flex',
                      color: 'white',
                      width: '120px',
                      justifyContent: 'center',
                    }}
                  >
                    ยกเลิกรายการ
                  </Button>
                </Popconfirm>
              ) : (
                ''
              )}

              <Button
                type="primary"
                style={{
                  display: 'flex',
                  backgroundColor: '#6B6B6B',
                  color: 'white',
                  width: '120px',
                  justifyContent: 'center',
                }}
                onClick={() => navigate('/')}
              >
                ปิด
              </Button>
            </Row>
          </Space>

          <CommentDetailForm form={form} onFinish={onSavePrescription} />
        </Spin>
      </DataContext.Provider>
    </div>
  );
};

export default PrescriptionForm;
